export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Luo kuva käyttämällä tekoälyä',
        requestFailed: 'Pyyntö epäonnistui',
        describeYourImage: 'Kuvaile kuvaasi',
        numberOfVariations: 'Vaihtoehtojen määrä',
        chooseStyle: 'Valitse kuvaustyylisi',
        descriptionPlaceholder: '(Esim.) Sinapinkeltaisten kukkien pelto kesäpäivänä tammipuiden kanssa',
        clear: 'selvä',
        generate: 'Tuottaa',
        seeAll: 'Näytä kaikki',
        tryAnExample: 'Kokeile esimerkkiä',
        tryAnother: 'Yritä toista',
    },
};
